var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { colors, createCssVars, cssVarsThemed } from '@creditornot/cb-ingredients';
import { rootCss as menuActionItemRootCss } from './MenuActionItem';
var colorCssVars = createCssVars(['rightContentText', 'rightContentTextSelected']);
var Root = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  text-decoration: none;\n\n  ", "\n"], ["\n  ", "\n  text-decoration: none;\n\n  ", "\n"])), menuActionItemRootCss, cssVarsThemed({
    rightContentText: {
        light: colors.pepper64,
        dark: colors.salt72,
    },
    rightContentTextSelected: {
        light: colors.salt100,
        dark: colors.space100,
    },
}));
var IconContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  padding-inline-end: 8px;\n\n  svg {\n    width: 16px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  padding-inline-end: 8px;\n\n  svg {\n    width: 16px;\n  }\n"])));
var Content = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: ", ";\n"], ["\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: ", ";\n"])), function (_a) {
    var fontWeight = _a.fontWeight;
    return (fontWeight === 'bold' ? 700 : 400);
});
var RightContent = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-inline-start: 8px;\n  text-align: end;\n  color: ", ";\n"], ["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-inline-start: 8px;\n  text-align: end;\n  color: ", ";\n"])), function (_a) {
    var selected = _a.selected;
    return selected ? colorCssVars.rightContentTextSelected : colorCssVars.rightContentText;
});
var MenuLinkItem = forwardRef(function (_a, ref) {
    var _b = _a.active, active = _b === void 0 ? false : _b, children = _a.children, _c = _a.disabled, disabled = _c === void 0 ? false : _c, icon = _a.icon, rightContent = _a.rightContent, _d = _a.tabIndex, tabIndex = _d === void 0 ? 0 : _d, _e = _a.variant, variant = _e === void 0 ? 'black' : _e, rest = __rest(_a, ["active", "children", "disabled", "icon", "rightContent", "tabIndex", "variant"]);
    return (React.createElement(Root, __assign({ disabled: disabled, "data-selected": active ? true : undefined, "data-highlighted": active ? true : undefined, ref: ref, tabIndex: tabIndex, variant: variant }, rest, { "data-cb-menu-item": true }),
        !!icon && React.createElement(IconContainer, null, icon),
        React.createElement(Content, { fontWeight: active ? 'bold' : 'normal' }, children),
        !!rightContent && React.createElement(RightContent, { selected: active }, rightContent)));
});
MenuLinkItem.displayName = 'MenuLinkItem';
export default MenuLinkItem;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=MenuLinkItem.js.map